import React, { useEffect } from 'react';
import { CollapseBlock } from '../../../common';
import { useTranslation } from 'react-i18next';
import { transformToUrl } from '../../../../utils/helpers/CommonHelper';
import FormTextEditor from '../../../antd/form/FormTextEditor/FormTextEditor';
import FormTextField from '../../../antd/form/FormTextField/FormTextField';
import { allAllowedTypes } from '../../../../hooks/useFileDraggerFileValidation';
import PropTypes from 'prop-types';
import { validateFieldFunc } from '../../../../utils/helpers/validation';
import { Form } from 'antd';
const LanguageBlock = ({
  language,
  title,
  onChange,
  formIsEmpty,
  formIsFilled,
  directory,
  form,
  closedByDefault = false,
}) => {
  const { t } = useTranslation();
  const validator = validateFieldFunc(formIsEmpty, formIsFilled, t);
  const languageFieldRules =
    directory === 'articles' ? [] : [{ validator: validator }];

  const titleValue = Form.useWatch(`title_${language}`, {
    form, preserve : true
  });
  let hasTitle = !!titleValue?.trim();

  useEffect(() => {
    if (!titleValue) {
      form.setFieldValue(`slug_${language}`, '');
      return;
    }

    form.setFieldValue(`slug_${language}`, transformToUrl(titleValue));
  }, [titleValue, language, form]);


  /*useEffect(() => {
    console.log(language + ' ' + hasTitle)
  }, [hasTitle]);
  */

  return (
    <CollapseBlock
      collapsible
      collapse={false}
      title={title}
      closedByDefault={closedByDefault}
      openOnTrigger={hasTitle}
    >
      <FormTextField
        className={'note-to-field'}
        label={<label className={'note-to-field'}>{t('Názov')}</label>}
        name={`title_${language}`}
        rules={languageFieldRules}
        onChange={(e) => {
          const newValue = e.target.value;
         // form.setFieldValue(`slug_${language}`, transformToUrl(newValue));
          onChange(newValue, 'title', language);
        }}
      />
      <FormTextField
        label={<label className={'note-to-field'}>{'URL'}</label>}
        name={`slug_${language}`}
        disabled
      />
      <FormTextEditor
        label={<label className={'note-to-field'}>{t('Obsah')}</label>}
        name={`content_${language}`}
        rules={languageFieldRules}
        imgUploadDirectory={directory}
        fileUploadDirectory={directory}
        allowedTypes={allAllowedTypes}
        enableCustomFileName={true}
        onChange={(e) => onChange(e, 'content', language)}
      />
    </CollapseBlock>
  );
};
LanguageBlock.propTypes = {
  onChange: PropTypes.func,
  title: PropTypes.string,
  language: PropTypes.string,
  creator: PropTypes.string,
  onSubmit: PropTypes.func,
  formIsEmpty: PropTypes.bool,
  formIsFilled: PropTypes.bool,
  directory: PropTypes.string,
  titleOrContentOf: PropTypes.string,
  form: PropTypes.object,
};

export default LanguageBlock;
